import React from 'react'
import * as firebase from 'firebase/app'
import 'firebase/auth'

class Container extends React.Component {
  componentDidMount() {
    const firebaseConfig = {
      apiKey: this.props.config.GOOGLE_CLOUD_PROJECT_IDENTITY_PLATFORM_API_KEY,
      authDomain: `${this.props.config.GOOGLE_CLOUD_PROJECT}.firebaseapp.com`,
    }

    if (this.props.config.SSR === false && !window.firebase) {
      firebase.initializeApp(firebaseConfig)
      window.firebase = firebase
    }
  }

  render() {
    return null
  }
}
export default Container
